exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-select[data-v-f45fdb2a] {\n  background: none !important;\n}\n.glassbox[data-v-f45fdb2a] {\n  cursor: pointer;\n}\n.inwardfooter[data-v-f45fdb2a] {\n  text-align: right !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f45fdb2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/stockCorrection/stockcorrection.component.scss
// module id = 1560
// module chunks = 0